import * as Yup from 'yup';

const hasPromocao = (vlPrecoPromocao) => {
    if (!vlPrecoPromocao) return false;
    const digits = vlPrecoPromocao.toString().replace(/[^\d]/g, '');
    return Number(digits) > 0;
};

const produtoSchema = Yup.object().shape({
    dsProduto: Yup.string().required('Campo obrigatório'),
    nrEan: Yup.string()
        .required('Campo obrigatório')
        .max(14, 'Máximo de 14 caracteres'),
    idDepartamento: Yup.string().required('Campo obrigatório'),
    vlPreco: Yup.string()
        .required('Campo obrigatório')
        .max(12, 'Valor máximo: R$ 99.999,99'),
    vlPrecoPromocao: Yup.string().max(12, 'Valor máximo: R$ 99.999,99'),
    dtInicioPromocao: Yup.mixed()
        .nullable()
        .when('vlPrecoPromocao', (vlPrecoPromocao, schema) => {
      if (hasPromocao(vlPrecoPromocao)) {
        return schema.required('Campo obrigatório');
      }
      return schema;
    }),
    dtFimPromocao: Yup.mixed()
        .nullable()
        .when('vlPrecoPromocao', (vlPrecoPromocao, schema) => {
      if (hasPromocao(vlPrecoPromocao)) {
                return schema.required('Campo obrigatório');
      }
      return schema;
    })
});

const configHorarioSchema = Yup.object({
    nrMinutoPreparo: Yup.string().required('Campo obrigatório'),
    vlPedidoMinimo: Yup.string()
        .required('Campo obrigatório')
        .test(
            'Valor minimo',
            'O valor mínimo do pedido deve ser R$15,00 para que seja possível efetuar o split dos valores pelo gateway de pagamento',
            (vlPedidoMinimo) => {
                if (!vlPedidoMinimo) {
                    return false;
                }

                const valorMinimo = parseFloat(
                    vlPedidoMinimo.replace(',', '.')
                );
                return valorMinimo >= 15;
            }
        )
});

const moneyFieldSchema = Yup.object({
    vlFrete: Yup.string().required('Campo obrigatório')
});

const modalFreteSchema = Yup.object({
    condition: Yup.object().required('Campo obrigatório'),
    vlCondicaoFrete: Yup.string().required('Campo obrigatório'),
    vlFrete: Yup.string().required('Campo obrigatório')
});

export {
    produtoSchema,
    configHorarioSchema,
    moneyFieldSchema,
    modalFreteSchema
};
